import { render, staticRenderFns } from "./PontuacaoEdit.vue?vue&type=template&id=789f4c24"
import script from "./PontuacaoEdit.vue?vue&type=script&lang=ts"
export * from "./PontuacaoEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports